import React from "react";
import Select from "react-select";
// import './MultiSelect.css';

const MultiSelect = ({
  options = [],
  value = "",
  onChange,
  placeholder = "Select",
}) => {
  // const formattedOptions = options.map((item) => ({
  //     value: item,
  //     label: item,
  // }));

  const formattedOptions = [
    ...options,
    ...(value && !options.includes(value) ? [value] : []),
  ].map((item) => ({
    value: item,
    label: item,
  }));

  return (
    <Select
      className="component-multi-select"
      // classNamePrefix="react-select"
      // classNamePrefix="multi-select"
      options={formattedOptions}
      placeholder={placeholder}
      isSearchable
      isClearable
      value={formattedOptions.find((item) => item.value === value) || null}
      onChange={(selected) => onChange(selected ? selected.value : "")}
      styles={{
        container: (base) => ({
          ...base,
          width: 90,
          borderRadius: "4px",
        }),
        control: (base, state) => ({
          ...base,
          minHeight: 30,
          height: 32,
          borderRadius: 8, // Smooth corners
          boxShadow: "none",
          // borderColor: state.isFocused ? "#2684FF" : "#d9d9d9",
          // "&:hover": {
          //   borderColor: "#2684FF",
          // },
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: 12,
          maxWidth: "none",
          overflow: "visible", // Show full text
          textOverflow: "unset", // Remove ...
          whiteSpace: "nowrap",
        }),
        valueContainer: (base) => ({
          ...base,
          height: 30,
          padding: "0 8px",
          borderRadius: "4px",
        }),
        placeholder: (base) => ({
          ...base,
          fontSize: 12,
          color: "#454545",
        }),
        indicatorsContainer: (base) => ({
          ...base,
          height: 30,
        }),
        dropdownIndicator: (base) => ({
          ...base,
          padding: 0,
          // color: "#181818",
        }),
        clearIndicator: (base) => ({
          ...base,
          padding: 2,
          "& svg": {
            width: 14,
            height: 14,
          },
        }),
        option: (base) => ({
          ...base,
          paddingTop: "2px",
          fontSize: 13,
          overflowX: "hidden",
        }),
      }}
    />
  );
};

export default MultiSelect;
